import React from 'react';

import DashboardHeader from './DashboardHeader';
import MailInsights from './MailInsights';
import MailSummary from './MailSummary';
import OrdersTable from './OrdersTable';
import PerformanceTable from './PerformanceTable';
import { getLastRefreshedLabel } from '../../utils';

const MailTrackingTab = ({
  dashboardWidgets,
  isLoading,
  isRefreshing,
  dateRange,
  onRefresh,
}) => {
  const mailData = dashboardWidgets?.mailPerformance;
  const areCardsDisabled =
    dashboardWidgets?.isDashboardCardsDisabled === true
    || mailData?.isDashboardCardsDisabled === true;

  return (
    <>
      <DashboardHeader
        title="Mail Performance"
        subtitle="Track your mailings, delivery, and spend in one place."
        lastRefreshed={getLastRefreshedLabel(mailData?.lastRefreshedAt)}
        isRefreshing={isRefreshing}
        dateRange={dateRange}
        onRefresh={onRefresh}
      />
      <div
        className={`dashboard-sample-content ${areCardsDisabled ? 'is-disabled' : ''}`}
        aria-disabled={areCardsDisabled || undefined}
        inert={areCardsDisabled ? '' : undefined}
      >
        <MailSummary mailData={mailData} isLoading={isLoading} />
        <MailInsights mailData={mailData} />
        <OrdersTable dashboardWidgets={dashboardWidgets} isLoading={isLoading} />
        <PerformanceTable dashboardWidgets={dashboardWidgets} isLoading={isLoading} />
      </div>
    </>
  );
};

export default MailTrackingTab;
